import ruGlossary from './lang_ru.js'
import enGlossary from './lang_en.js'

let glossary;

function t(key) {
    return glossary[key] ? glossary[key] : key;
}

function setLang(lang) {
    switch (lang) {
        case 'ru':
            glossary = ruGlossary();
            break;
        case 'en':
            glossary = enGlossary();
            break;
    }
}

export { t, setLang };